import * as Icon from "react-bootstrap-icons";

export default function OrderFlag ({color}) {
    return(
        <Icon.FlagFill color={color}/>
        );
}

